import { cn, ia, iaRa } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';
import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

import CardOption from './components/CardOption';
import NewCardOption from './components/NewCardOption';

const CardGroup = ({ label, children }) => (
  <div className="flex flex-col gap-3">
    <Typography variant="p" size="small" color="neutral-800">
      {label}
    </Typography>
    {children}
  </div>
);

const CardPicker = ({
  cards,
  tempCardId = null,
  selectedCardId,
  onSelectCard,
  onUseAnotherCard,
  isNewCardChosen = false,
  hasNewCardOption = false,
  canAddNewCard = true,
  renderBadge,
  scrollRef,
  isScrollable = false,
  isFetchingNextPage = false,
  children
}) => {
  const allCards = iaRa(cards);
  const tempCard = allCards.find((card) => card.id === tempCardId) || null;
  const savedCards = allCards.filter((card) => card.id !== tempCardId);
  const hasCards = !!tempCard || ia(savedCards);

  return (
    <>
      {tempCard && (
        <CardGroup label="Recently added">
          <CardOption
            card={tempCard}
            isSelected={selectedCardId === tempCard.id}
            note={
              selectedCardId === tempCard.id
                ? null
                : "This card will be discarded when you're done."
            }
            onSelect={onSelectCard}
          />
        </CardGroup>
      )}
      {ia(savedCards) && (
        <div
          ref={scrollRef}
          className={cn('flex flex-col gap-3 p-1', isScrollable && 'max-h-80 overflow-y-auto')}>
          {savedCards.map((card) => (
            <CardOption
              key={card.id}
              card={card}
              isSelected={selectedCardId === card.id}
              badge={renderBadge?.(card)}
              onSelect={onSelectCard}
            />
          ))}
          {isFetchingNextPage && (
            <div
              role="status"
              aria-live="polite"
              aria-label="Loading more cards"
              className="flex justify-center py-1">
              <Icon icon="loader-linear" className="animate-spin" color="primary" size={24} />
            </div>
          )}
        </div>
      )}
      {hasCards && canAddNewCard && hasNewCardOption && isNewCardChosen && (
        <NewCardOption onDismiss={onUseAnotherCard}>{children}</NewCardOption>
      )}
      {hasCards && canAddNewCard && (!hasNewCardOption || !isNewCardChosen) && (
        <div className="flex items-center gap-4">
          <div className="h-px flex-1 bg-neutral-200" />
          <Button
            text="Use another card"
            icon="add-square-mono"
            size="small"
            color="neutral"
            style="outlined"
            className={cn(isNewCardChosen && '!bg-neutral-100')}
            onClick={onUseAnotherCard}
          />
          <div className="h-px flex-1 bg-neutral-200" />
        </div>
      )}
      {(!hasCards || !hasNewCardOption) && children}
    </>
  );
};

export default CardPicker;
